import {Button} from 'platform/components';
import {HStack, VStack} from 'platform/foundation';

import type {CheckoutProfile} from '@dms/api/sales';
import i18n from '@dms/i18n';
import {DmsDataGrid} from '@dms/shared';

import type {QueryFilterObject} from 'features/eag-grid';

import {useCheckoutRuleActions} from '../../../hooks/useCheckoutRuleActions';

export function CheckoutProfileRules(props: {profile: CheckoutProfile}) {
  const actions = useCheckoutRuleActions(props.profile);
  const filterRules = (filters: QueryFilterObject): QueryFilterObject => ({
    ...filters,
    checkoutProfileId: props.profile.id,
  });

  return (
    <VStack spacing={4}>
      <HStack justify="flex-end">
        <Button
          title={i18n.t('entity.checkout.actions.createNewCheckoutRule')}
          onClick={actions.onCreate}
        />
      </HStack>
      <DmsDataGrid
        key={props.profile.id}
        gridCode="checkout-profile-rule"
        queryModifier={filterRules}
        predefinedColumns={actions.predefinedColumns}
        actionCallback={actions.actionCallback}
        autoHeight
        data-testid="checkout-profile-assignment-rules"
      />
    </VStack>
  );
}
